import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";


class Vidyamap extends Component {

    render() {
        const { user } = this.props.auth;

        return(
            <div>
                <form action='https://vidyamap.staging.wceruw.org/#/' method='POST'>
                    <textarea style={{marginLeft: -600}} name='Authorization' id='Authorization' rows="6" cols="50" defaultValue={user.vidyamapAuth}></textarea>
                    <br />
                    <button style={{ marginLeft: 250, marginTop: 50, height: 100, width: 200 }} type='submit'>Proceed to Vidyamap!</button>
                </form>
            </div>
        );
    }
}

Vidyamap.propTypes = {
    auth: PropTypes.object.isRequired,
    lesson: PropTypes.object.isRequired,
    navigation: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    lesson: state.lesson,
    navigation: state.navigation
});

export default connect(
    mapStateToProps
) (Vidyamap);